/** Класс представляющий капчу. */
/* eslint-disable */
class CRecaptcha {
  /**
   * Загрузка данных после того как загрузилась сама капча
   */
  load() {
    this._isLoad = true;
    this._stash.forEach((item) => {
      this.add(item.el, item.callback);
    });
  }
  /**
   * Конструктор
   * @constructor
   * @param {string} sitekey - Ключ капчи для сайта.
   */
  constructor(sitekey) {
    this._sitekey = sitekey;
    this._isLoad = false;
    this._stash = [];
  }

  /**
   * Установка ключа
   * @param {string} sitekey - Ключ капчи для сайта.
   */
  setKey(sitekey) {
    this._sitekey = sitekey;
  }

  /**
   * Создание элемента под капчу.
   * @param {HTMLElement} nextSibling - Элемент для которого необходимо сделать капчу.
   * @returns {HTMLElement} - Созданный элемент
   */
  static createElement(nextSibling) {
    const div = document.createElement('div');
    div.dataset.size = 'invisible';
    nextSibling.parentElement.insertBefore(div, nextSibling);
    return div;
  }

  /**
   * Добавление капчи
   * @param {HTMLElement} el - Элемент на который будет действие капчи
   * @param {function} callback - Функция которую необходимо вызывать
   */
  add(el, callbackFn) {
    if (this._isLoad) {
      el.grecaptchaInfo = {};
      const params = {
        sitekey: this._sitekey,
        callback: (token) => {
          el.grecaptchaInfo.token = token;
          // callbackFn(token);
        },
      };
      const div = CRecaptcha.createElement(el);
      const id = window.grecaptcha.render(div, params);
      el.grecaptchaInfo.id = id;
      el.grecaptchaInfo.callback = callbackFn;
      // window.grecaptcha.execute(el.grecaptchaInfo.id);
    } else {
      this._stash.push({
        el,
        callback: callbackFn,
      });
    }
  }

  /**
   * Вызов капчи
   * @param {HTMLElement} el - Элемент на который будет действие капчи
   */
  run(el) {
    if (this._isLoad) {
      if (!el.grecaptchaInfo.token) {
        window.grecaptcha.execute(el.grecaptchaInfo.id);
        const intervalT = setInterval(() => {
          if (el.grecaptchaInfo.token) {
            clearInterval(intervalT);
            el.grecaptchaInfo.callback(el.grecaptchaInfo.token);
          }
        }, 100);
      } else {
        el.grecaptchaInfo.callback(el.grecaptchaInfo.token);
      }
    }
  }
}

/** Создаем синглтон с ключом по умолчанию */
const recaptcha = new CRecaptcha();
export default recaptcha;

export const Recaptcha = CRecaptcha;
/* eslint-enable */



// WEBPACK FOOTER //
// ./base/script/recaptcha.js